import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { colors } from 'styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    cardActions: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: '20px',
      padding: '1vh 0 2vh',
    },
    cardContent: {
      height: '20vh',
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
      },
    },
    root: {
      maxWidth: 345,
      margin: '2vh 2vw',
    },
    tags: {
      // border: `1px solid ${colors.white}`,
      // borderRadius: '10px',
      backgroundColor: colors.greyBrand,
      color: colors.white,
      fontSize: '0.7rem',
      margin: '1vh 0.2vw 0',
      textAlign: 'center',
      textShadow: '2px 2px 2px rgba(100, 100, 100, 0.2)',
      [theme.breakpoints.down('sm')]: {
        fontSize: '1rem',
        margin: '1vh 0.2vw 0',
        textAlign: 'center',
        width: '100%',
      },
    },
    title: {
      color: colors.greyBrand,
      fontSize: '1.2rem',
      fontWeight: 500,
      textAlign: 'left',
      [theme.breakpoints.down('sm')]: {
        fontSize: '1rem',
        textAlign: 'center',
      },
    },
  })
);
